import { EventDetailMemberInfo } from "@models/data-contracts";
import BaseUserProfileViewModel from "@domains/common/viewModel/BaseUserProfileViewModel";

class ParticipantViewModel extends BaseUserProfileViewModel {
  participantId?: number;

  static create(responseData: EventDetailMemberInfo) {
    const participant = new ParticipantViewModel(responseData);

    participant.participantId = responseData.id;

    return participant;
  }
}

export default ParticipantViewModel;
